export const GOOGLE_API = {
  DATA_API_BASE_URL: "https://analyticsdata.googleapis.com/v1beta",
  TOKEN_URL: "https://oauth2.googleapis.com/token",
  SCOPE: "https://www.googleapis.com/auth/analytics.readonly",
} as const;

export const GA_DATE_RANGES = [
  { startDate: "2daysAgo", endDate: "today" },
] as const;

export const ONE_HOUR_CACHE_CONTROL = "max-age=3600";
export const TRENDING_TOPICS_CACHE_KEY: string = "trending_topics";
export const TRENDING_TOPICS_CACHE_EXPIRY_SECONDS: number = 3 * 60 * 60;
export const HOME_TRENDING_TOPICS_LIMIT: number = 20;

export const MAX_KEYWORDS_FOR_ALIAS_LOOKUP = 50;
export const MYBH_TRENDING_TOPICS_LIMIT = MAX_KEYWORDS_FOR_ALIAS_LOOKUP;
export const MYBH_TRENDING_TOPICS_PAGE_SIZE = 10;
export const MAX_TAG_ALIAS_SEARCH_HITS = 10;
export const TREND_ICON_THRESHOLD = 5;
